export default __webpack_public_path__ + "static/element_different-a24fed8639c7c0df4669337c9799a703.png";